export default {
  methods: {
    bgColorFromSlug(slug) {
      return process.env.MIX_BRAND_BACKGROUND_COLOR ?? 'gray-800';
    },

    textColorFromSlug(slug) {
      return process.env.MIX_BRAND_TEXT_COLOR ?? 'white';
    },
  },
};
